<template>
  <div>
    <form ref="form" data-vv-scope="form" @submit="attemptRecover">
      <vs-input
        name="correo"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Correo electrónico"
        v-model="correo"
        class="w-full"
        v-validate="'required|email'"
        :danger="errors.has('form.correo')"
        :danger-text="errors.first('form.correo')"
      />
      <div class="d-flex justify-content-between align-items-start mt-5">
        <b-button
          variant="flat-secondary"
          class="close-button mr-4"
          v-on:click="closeForm"
        >
          Ya recordé, mejor no
        </b-button>
        <vs-button
          class="btn-ingresar mb-10"
          v-on:click="attemptRecover()"
        >
          Enviar
        </vs-button>
      </div>
    </form>
  </div>
</template>
<script>

import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import { forgotPassword } from '@/febos/servicios/api/usuarios.api';

export default {
  mixins: [I18nMixin, PersonalizacionMixin],
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      correo: ''
    };
  },
  methods: {
    async attemptRecover(e) {
      if (e) {
        e.preventDefault();
      }
      this.$vs.loading();
      try {
        await forgotPassword({
          correo: this.correo,
          portal: process.env.VUE_APP_PORTAL,
          dominio: window.location.hostname.toLocaleLowerCase()
        });
        this.$bvToast.toast(
          'Genial! Se ha enviado tu solicitud de recuperación de clave',
          {
            title: 'Recuperación de clave',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        setTimeout(() => {
          this.$emit('close');
        }, 500);
      } finally {
        this.$vs.loading.close();
      }
    },
    closeForm() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
  .close-button {
    padding: 13px;
    border-radius: 4px;
  }
</style>
